import React from 'react';
import { BackIcon } from 'components';

export default function ToolbarBackButton({ handleOnClick }) {
	return <BackIcon onClick={handleOnClick} />;
}
